<style lang="scss" scoped>
.left-menu {
    border-right: 1px solid rgb(240,242,245);
    width: 20% !important;
}
.right-menu {
    margin-left: 50px;
    width: 80%
}
.right-title {
    font-size: 24px;
    color: rgb(24,144,255)
}
.right-content {
    border-left: 5px solid rgb(24,144,255);
    padding-left: 10px;
    margin-bottom: 10px;
}
.right-content-2 {
    padding: 5px 15px;
    background: rgb(240,242,245);
}
.ivu-menu-item-active {
    color: white !important;
    background: #2d8cf0 !important;
}
</style>
<template>
    <section class="margin-15">
        <div style="display:flex">
            <Menu class="left-menu" :active-name=type @on-select="select">
                <MenuItem :name="1" style="text-align:center">{{$t('fbb.transfer.ordinary_transfer_between', {defaultValue: '仓仓调拨'})}}</MenuItem>
                <MenuItem :name="2" style="text-align:center">{{$t('fbb.transfer.ordinary_transfer_out', { defaultValue: "调拨出库" })}}</MenuItem>
            </Menu>
            <div class="right-menu">
                <div v-if="type == 1" style="padding:5px 0;">
                    <header>
                        <span class="right-title">{{$t('fbb.transfer.ordinary_transfer_between', {defaultValue: '仓仓调拨'})}}</span>
                        <span class="margin-left-20">{{$t('fbb.ordinarytransfer.inprompt', { defaultValue: "同一个三方仓体系内的仓库间调拨" })}}</span>
                    </header>
                    <section class="margin-top-10">
                        <div class="right-content">
                            {{$t('fbb.fbatransfer.standardservice', { defaultValue: "标准服务" })}}
                        </div>
                        <div class="right-content-2" v-html="$t('fbb.ordinarylist.waretoware_standard_service',{defaultValue:'仓仓调拨标准服务'})"></div>
                    </section>
                    <section class="margin-top-10">
                        <div class="right-content">
                            {{$t('fbb.fbatransfer.addedservice', { defaultValue: "增值服务" })}}
                        </div>
                        <div class="right-content-2" v-html="$t('fbb.ordinarylist.waretoware_added_service',{defaultValue:'仓仓调拨逊增值服务'})"></div>
                    </section>
                </div>
                <div v-else style="padding:5px 0;">
                    <header>
                        <span class="right-title">{{$t('fbb.transfer.ordinary_transfer_out', { defaultValue: "调拨出库" })}}</span>
                        <span class="margin-left-20">{{$t('fbb.ordinarytransfer.outprompt', { defaultValue: "从COPE仓发到其他外部仓库或指定地点" })}}</span>
                    </header>
                    <section class="margin-top-10">
                        <div class="right-content">
                            {{$t('fbb.fbatransfer.standardservice', { defaultValue: "标准服务" })}}
                        </div>
                        <div class="right-content-2" v-html="$t('fbb.ordinarylist.wareout_standard_service',{defaultValue:'调拨出库标准服务'})"></div>
                    </section>
                    <section class="margin-top-10">
                        <div class="right-content">
                            {{$t('fbb.fbatransfer.addedservice', { defaultValue: "增值服务" })}}
                        </div>
                        <div class="right-content-2" v-html="$t('fbb.ordinarylist.wareout_added_service',{defaultValue:'调拨出库增值服务'})"></div>
                    </section>
                </div>
            </div>
        </div>
        <vButtonGroup class="text-right margin-top-30">
            <vButton theme="primary" @click="create">{{$t('global.common.create', { defaultValue: '创建' })}}</vButton>
            <vButton @click="cancel">{{$t("global.common.return", { defaultValue: "返回" })}}</vButton>
        </vButtonGroup>
    </section>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            type: 1,
        };
    },
    computed: {},
    methods: {
        select(name){
            this.type = name
        },
        create() {
            this.$router.push({
                name: this.type == 1 ? "ordinaryTransferInDetail" : "ordinaryTransferOutDetail",
                params: { type: "add",},
            });
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
